import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useDarkMode } from '../../contexts/DarkModeContext';
import { Crown } from 'lucide-react';
import { MenuDropdown } from '../MenuDropdown';

export const HomeHeader = ({
  isMasterUser,
  onSignOut,
}) => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();

  return (
    <div style={{
      ...styles.header,
      ...(isDarkMode ? styles.headerDark : {}),
    }}>
      <div style={styles.menuContainer}>
        <MenuDropdown
          onNewsPress={() => navigate('/news')}
          onCollectionPress={() => navigate('/my-collection')}
          onUpdatesPress={() => navigate('/updates')}
          onCommissionsPress={() => navigate('/commissions')}
          onCommissionsGalleryPress={() => navigate('/commissions-gallery')}
          onInfoPress={() => navigate('/info')}
          onSettingsPress={() => navigate('/settings')}
          onSignOutPress={onSignOut}
          isDarkMode={isDarkMode}
          isMasterUser={isMasterUser}
        />
      </div>
      
      {/* Master Badge - shows when user has master access */}
      {isMasterUser && (
        <div className="fp-master" data-testid="master-badge">
          <span className="fp-master-spark" style={{ top: '-7px', left: '-6px' }}>✦</span>
          <span className="fp-master-spark" style={{ bottom: '-8px', right: '14px', animationDelay: '0.9s' }}>✦</span>
          <span className="fp-master-spark" style={{ top: '-9px', right: '-5px', animationDelay: '1.7s', fontSize: '9px' }}>✦</span>
          <div className="fp-master-plate">
            <Crown className="fp-master-crown" size={14} color="#2a1200" fill="#fff6a8" strokeWidth={2.6} />
            <span>MASTER</span>
          </div>
        </div>
      )}
      
      {/* with the badge on the right, the logo moves a little to the left to make room */}
      <img src="/logo.png" alt="FootParadise Comics" style={isMasterUser ? { ...styles.logo, left: 'calc(50% - 18px)' } : styles.logo} />
      <div style={styles.spacer} />
    </div>
  );
};

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 14px 12px',
    paddingTop: 'max(10px, env(safe-area-inset-top))',
    background: 'linear-gradient(180deg, #2a0d55 0%, #1b0a33 100%)',
    color: 'white',
    flexShrink: 0,
    position: 'sticky',
    top: 0,
    zIndex: 50,
    borderBottom: '3px solid #000',
    boxShadow: '0 3px 0 #ff2d95, 0 8px 16px rgba(0, 0, 0, 0.45)',
  },
  headerDark: {
    background: '#000000',
    borderBottom: '1px solid #333',
    boxShadow: 'none',
  },
  menuContainer: {
    width: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  logo: {
    height: '27px',
    width: 'auto',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    objectFit: 'contain',
  },
  spacer: {
    width: '48px',
  },
};

export default HomeHeader;
